import $ from 'jquery';

/**
 * カテゴリー選択の状態を保持するためのストレージキー
 * @type {string}
 */
let STORAGE_KEY = 'stocksSelectedCategories';

/**
 * カテゴリー選択の種類に応じたストレージキーのマッピング
 * @constant
 * @type {Object.<string, string>}
 */
const STORAGE_KEYS = {
  Stock: 'stocksSelectedCategories',
  ListingStock: 'listingStocksSelectedCategories',
  CategoryStock: 'categoryStocksSelectedCategories'
};

/**
 * ページロード時の初期化処理
 * @listens turbolinks:load
 * @fires /categories/roots APIリクエスト
 */
document.addEventListener('turbolinks:load', () => {
  // STORAGE_KEYの呼び出し元によって上書き
  const container = $('#category-selects');
  const storageType = container.data('storage-key');
  STORAGE_KEY = STORAGE_KEYS[storageType] || 'stocksSelectedCategories';

  // すでにカテゴリセレクトがある場合は再生成しない
  if (container.length === 0 || container.find('.category-select-wrapper').length > 0) return;

  // 最上位カテゴリの取得と初期セレクトの生成
  const storedCategories = getStoredCategories();
  let selectedCategoryId;

  if (STORAGE_KEY === 'categoryStocksSelectedCategories') {
    selectedCategoryId = container.data('category-id');
    // 初期表示とリロード時はカテゴリー選択をリセット
    localStorage.removeItem(STORAGE_KEY);

    // 親カテゴリレベルの生成
    const categoryDepth = parseInt(container.data('category-depth'), 10) || 0;
    const parentCategories = container.data('parent-categories') || [];

    // 各親カテゴリレベルのセレクトを生成
    for (let i = 0; i < categoryDepth; i++) {
      if (parentCategories[i]) {
        createDisabledCategorySelect(i + 1, parentCategories[i]);
      }
    }

    // category-depthの次の階層から子カテゴリ取得を開始
    loadChildCategoriesRecursively(selectedCategoryId, categoryDepth + 1);
  } else {
    selectedCategoryId = storedCategories.level_1;

    // 通常のカテゴリ選択の場合はroots APIから取得
    $.get('/categories/roots', (data) => {
      createCategorySelect({
        level: 1,
        parentId: null,
        categories: data,
        selectAllText: container.data('select-all'),
        selectedValue: selectedCategoryId // 選択状態を復元
      });
    });
  }
});

/**
 * ブラウザバック時にカテゴリセレクトをクリア
 * @listens turbolinks:before-cache
 */
document.addEventListener('turbolinks:before-cache', () => {
  $('#category-selects .category-select-wrapper').remove();
});

/**
 * 選択済みのカテゴリーに応じて再帰的に子カテゴリーをロード
 * @param {number} parentId - 親カテゴリID
 * @param {number} level - 階層レベル
 * @fires /categories/children APIリクエスト
 */
function loadChildCategoriesRecursively(parentId, level) {
  const storedCategories = getStoredCategories();

  $.get('/categories/children', { parent_id: parentId }, (childData) => {
    if (childData.length > 0) {
      const nextCategory = storedCategories[`level_${level}`]; // 事前に選択されていたカテゴリーを探す
      createCategorySelect({
        level: level,
        parentId: parentId,
        categories: childData,
        selectAllText: $('#category-selects').data('select-all'),
        selectedValue: nextCategory
      });

      if (nextCategory && childData.some(cat => cat.id === parseInt(nextCategory))) {
        loadChildCategoriesRecursively(nextCategory, level + 1);
      }
    }
  });
}

/**
 * カテゴリー選択要素の生成と設定
 * @param {Object} params - 設定パラメータ
 * @param {number} params.level - 階層レベル
 * @param {number|null} params.parentId - 親カテゴリID
 * @param {Array} params.categories - カテゴリーデータ配列
 * @param {string} params.selectAllText - 全選択時のテキスト
 * @param {string} [params.selectedValue=''] - 選択値
 */
function createCategorySelect({ level, parentId, categories, selectAllText, selectedValue = '' }) {
  const container = $('#category-selects');
  removeLowerLevels(level - 1); // 下位レベルの選択肢を削除（既存のをクリア）

  const selectWrapper = $(`<div class="category-select-wrapper level-${level} col-md-12 d-flex"></div>`);
  const select = $('<select></select>')
    .addClass(`category-select-level-${level} form-control w-100`)
    .append($('<option>').val('').text(selectAllText)) // 「すべて」を選択肢に追加
    .val(selectedValue); // 選択状態を復元

  // CategoryStockの場合、category-depthに基づいて親カテゴリをdisabledにする
  if (STORAGE_KEY === 'categoryStocksSelectedCategories') {
    const categoryDepth = parseInt(container.data('category-depth'), 10) || 0;

    // jQuery.data()が既にJSONをパースしている場合の対応
    let parentCategories = container.data('parent-categories');
    if (!parentCategories) {
      parentCategories = [];
    } else if (typeof parentCategories === 'string') {
      // まだ文字列の場合はパースする
      parentCategories = JSON.parse(parentCategories || '[]');
    }

    // 現在のレベルが親カテゴリの深さ以下なら、対応する親カテゴリを表示してdisabledにする
    if (level <= categoryDepth) {
      const parentCategoryIndex = level - 1; // 配列のインデックスは0始まりなのでlevel-1
      if (parentCategories[parentCategoryIndex]) {
        const parentCategory = parentCategories[parentCategoryIndex];
        select.empty() // 既存のoptionsを全て削除
        .append($('<option>')
          .val(parentCategory.id)
          .text(parentCategory.name))
        .prop('disabled', true);
      }
    }
  }

  select.on('change', function() {
    const selectedValue = $(this).val();
    removeLowerLevels(level); // 下位セレクトを削除
    $('#hidden_category_id').val(selectedValue || parentId || '');

    // 選択状態を保存
    saveSelectedCategories(level, selectedValue);

    // 子カテゴリの取得と次の階層のセレクト生成
    if (selectedValue) {
      loadChildCategoriesRecursively(selectedValue, level + 1);
    }
  });

  categories.forEach(({ id, name }) => select.append($('<option>').val(id).text(name))); // カテゴリを追加
  container.append(selectWrapper.append(select));

  // 選択状態を復元して、イベントをトリガー
  if (selectedValue) {
    select.val(selectedValue).trigger('change');
  }
}

/**
 * 親カテゴリ用のdisabled状態のセレクトを生成
 * @param {number} level - 階層レベル
 * @param {Object} parentCategory - 親カテゴリオブジェクト
 */
function createDisabledCategorySelect(level, parentCategory) {
  const container = $('#category-selects');
  const selectWrapper = $(`<div class="category-select-wrapper level-${level} col-md-12 d-flex"></div>`);
  const select = $('<select></select>')
    .addClass(`category-select-level-${level} form-control w-100`)
    .append($('<option>')
      .val(parentCategory.id)
      .text(parentCategory.name))
    .prop('disabled', true);

  container.append(selectWrapper.append(select));
}

/**
 * 指定レベルより下位の選択要素を削除
 * @param {number} currentLevel - 基準となる階層レベル
 */
function removeLowerLevels(currentLevel) {
  $('#category-selects .category-select-wrapper').each(function() {
    const levelMatch = $(this).attr('class').match(/level-(\d+)/);
    const level = levelMatch ? parseInt(levelMatch[1], 10) : 0;
    if (level > currentLevel) {
      $(this).remove();
    }
  });
}

/**
 * 選択されたカテゴリーをローカルストレージに保存
 * @param {number} level - 階層レベル
 * @param {string} categoryId - カテゴリーID
 */
function saveSelectedCategories(level, categoryId) {
  let savedCategories = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  savedCategories[`level_${level}`] = categoryId;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(savedCategories));
}

/**
 * ローカルストレージから保存されたカテゴリー情報を取得
 * @returns {Object} 保存されているカテゴリー選択状態
 */
function getStoredCategories() {
  return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
}
